import { AdminRoleLabels } from "entities/auth/constants";

export const roleOptions: { id: string; name: string }[] = Object.entries(
  AdminRoleLabels,
).map(([key, role]) => ({
  id: key,
  name: role.label,
}));
